import React, { useState, useEffect } from "react";
import { Container } from "olive-react-myoneui";
import { useParams } from "react-router-dom";
import CourseCurriculum from "../../components/student-dashboard/course-curriculum";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import axios from "../../utils/axios";

function CourseCurriculumOverview() {
  let { id } = useParams();
  console.log(id,"id")
  const courseDetail = async () => {
    try {
      var origin = window.location.origin;
      // const headers = {
      //   'Content-Type': 'application/json',
      //   'Authorization': `Bearer ${configData.access_token}`
      // }
      axios.get(`api/course/view/67`, {
        // headers
      })

        .then((response) => {
            console.log(response)
        })
        .catch(err => {

          console.log(err.response.status,"status");
        });
     
    } catch (error) {
      console.log("Init Error", error);
    }
  };

  useEffect(() => {
    courseDetail();
  }, []);

  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <div className="dashboard-wrapper course-curriculum-overview w-100">
        <CourseCurriculum />
      </div>
      <Footer />
    </>
  );
}

export default CourseCurriculumOverview;
